import GelLane from './GelLane';
import { useState } from 'react';


let blankLanes = Array(15).fill(null).map(x => Array(4).fill(null));
const data = JSON.parse(JSON.stringify(blankLanes));

data.forEach((lane,ii) => {
  data[ii][0] = "WT";
  data[ii][1] = ["+","—"][(ii % 2)]
})


export default function Gel({gel}){

  const [ lanes, setLanes ] = useState(blankLanes);





  return (

    <div style={{
      
    }} class="sg-row">
      {lanes.map((lane,laneIndex) => (
        <GelLane onEvent={() => {
          setLanes(data);
        }} lane={lane} laneIndex={laneIndex}/>
      ))}
    </div>

  )

}
